"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insert = insert;
exports.getAllByAffaireId = getAllByAffaireId;

var _request = _interopRequireDefault(require("@/helpers/request"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function insert(data) {
  return (0, _request.default)({
    url: '/provision_risque',
    method: 'post',
    data: data
  });
}

function getAllByAffaireId(id) {
  return (0, _request.default)({
    url: '/provision_risque/affaire/' + id,
    method: 'get'
  });
}